import React, { useEffect, useContext } from "react";
import { useLocation } from "react-router";
import axiosPrivate from "../../../hooks/axiosPrivate";
import LoaderContext from "../../../context/Loader/LoaderContext";

function CrmPayment() {
  const { setLoaderCheck } = useContext(LoaderContext);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const payload = {
      data: token
    };
        
    setLoaderCheck(true);
    axiosPrivate
      .post("orders/createcrm", payload)
      .then((res) => {
        const payuFormHtml = res.data;
        if (payuFormHtml) {
          const div = document.createElement("div");
          div.innerHTML = payuFormHtml;
          const form = div.querySelector("form");
          if (form) {
            document.body.appendChild(form);
            form.submit();
          }
        }
      })
      .catch((err) => {
        setLoaderCheck(false);
        console.error(err);
      });
  }, []);

  return (
    <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <h2>Redirecting to secure payment...</h2>
    </div>
  );
}

export default CrmPayment;
